import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select, { createFilter } from "react-select";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import useFetchUserOptions from "../../../hooks/useFetchUserOptions";

const API_URL = process.env.REACT_APP_API_URL;

const AddAnswer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [newAnswer, setNewAnswer] = useState("");
  const users = useFetchUserOptions(true);
  const [selectedUser, setSelectedUser] = useState([]);

  const handleAddAnswer = async (e) => {
    try {
      e.preventDefault();
      let formErrors = {};

      if (!newAnswer.trim() || newAnswer === "<p><br></p>") {
        formErrors.newAnswer = "Answer is required";
      }
      if (Object.keys(formErrors).length > 0) {
        for (const key in formErrors) {
          toast.error(formErrors[key], { autoClose: 1000 });
        }
        return;
      }

      let obj = {
        questionId: id,
        answerDescription: newAnswer,
        userId: selectedUser.value,
      };

      await axios.post(`${API_URL}/answers/addAnswer`, obj);
      setNewAnswer("");
      setSelectedUser([]);
      navigate(`/questions`);
    } catch (error) {
      toast.error("Please enter an answer and select users", {
        autoClose: 1000,
      });
    }
  };

  return (
    <form onSubmit={handleAddAnswer}>
      <div className="form-group">
        <label>Write Answer:</label>
        <ReactQuill
          value={newAnswer}
          onChange={setNewAnswer}
          placeholder="Write the answer here..."
        />
      </div>

      <div
        className="form-group"
        style={{
          color: "#000000ab",
          fontSize: "13px",
        }}
      >
        <label>Select User to Answer:</label>
        <Select
          options={users}
          value={selectedUser}
          onChange={setSelectedUser}
          filterOption={createFilter({ ignoreAccents: false })}
          placeholder="Search and select users"
        />
      </div>

      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
      >
        Save
      </button>
    </form>
  );
};

export default AddAnswer;
